import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { FormControl, InputLabel } from '@material-ui/core'

const IconTypeSelector = props =>
  <FormControl fullWidth>
    <InputLabel shrink htmlFor="iconType">
      Type
    </InputLabel>
    <Select onChange={props.onChange} value={props.value} placeholder="Type" fullWidth inputProps={{
              name: 'type',
              id: 'iconType',
            }}>
      <MenuItem value="filled">Filled</MenuItem>
      <MenuItem value="outline">Outline</MenuItem>
      <MenuItem value="sharp">Sharp</MenuItem>
    </Select>
  </FormControl>

export default IconTypeSelector